module.exports = __webpack_public_path__ + "img/art5-img3.db1c6e03.jpeg";